import { useContent } from '@eneco/cms';
import { useFormContext } from 'react-hook-form';

import type { FormFieldComponent } from './types';

interface HiddenFieldContent {
  fieldName?: string;
  value?: string;
}

const NAME_FALLBACK = 'inputFormHiddenField';

/**
 * A fixed key/value submitted with the form. Mirrors
 * `libs/sitecore/components/forms/src/GenericForm/Components/GenericFormInputHiddenField/GenericFormInputHiddenField.tsx`.
 * Declares no `formSchema`, like the legacy field: `buildFormSchema` keeps unknown keys, so the value
 * still reaches the request.
 */
const GenericFormInputHiddenField: FormFieldComponent = () => {
  const { register } = useFormContext();
  const content = useContent<HiddenFieldContent>();

  if (content?.fieldName === undefined && content?.value === undefined) {
    return null;
  }

  const name = content.fieldName || NAME_FALLBACK;
  const value = content.value || '';

  return <input value={value} type="hidden" {...register(name)} />;
};

export default GenericFormInputHiddenField;
